module.exports = __webpack_public_path__ + "img/icon_map_6_off_011.4e979e85.png";